import PageContainer from '../components/common/PageContainer'
import { useGetAllProcesses } from '../api/process'
import ProcessOverview from '../components/process/ProcessOverview'
import ProcessPageHeader from '../components/process/ProcessPageHeader'
import { Step } from 'intro.js-react'

export default function Processes() {
  const { data: processes } = useGetAllProcesses()
  return (
    <PageContainer introSteps={steps} header={<ProcessPageHeader />}>
      <ProcessOverview processes={processes} />
    </PageContainer>
  )
}

const steps: Step[] = [
  {
    element: '#create-button',
    intro: 'می‌توانید از این قسمت، فرایند  یا کاربر جدید تعریف کنید',
  },
  {
    element: '#processes-list',
    intro: 'در اینجا لیست فرایند‌های درحال اجرا را می‌بینید.',
  },
  {
    element: '.process-card',
    intro: 'وضعیت هر فرایند را می‌توانید از اینجا ببینید.',
  },
  {
    element: '.process-deadline',
    intro: 'زمان طی شده و موعد اتمام فرایند',
  },
  {
    element: '.card-details',
    intro: 'از این قسمت به جزییات فرایند مانند دسترسی‌ها بروید.',
  },
]
